import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IPartnerImage, PartnerImage } from "@/models/partner-image.entity";

export const PartnerImageDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IPartnerImage> {
  getIdentifier(entity: IPartnerImage): string {
    return entity.id;
  }

  protected mapEntity(entity: IPartnerImage): IPartnerImage {
    return new PartnerImage(entity);
  }
})();
